module.exports = __webpack_public_path__ + "img/hkcs.c8ce6ddb.png";